import { AnalogInput, } from 'z3k-config';
import { getFieldParser, multi_converters, number_or_0, objectid_array_or_empty, objectid_or_null, physical_converters, string_or_empty, } from '../../utils/parser-utils';
import { ObjectLine } from 'z3k-parser/parser/utils/object-line';
const analog_input_fields = [
    {
        name: 'physical_input_num',
        ...physical_converters,
    },
    { name: 'name', ...string_or_empty },
    { name: 'upper_threshold', ...number_or_0 },
    { name: 'lower_threshold', ...number_or_0 },
    {
        name: 'active_level_timeout',
        ...multi_converters(1000),
    },
    {
        name: 'inactive_level_timeout',
        ...multi_converters(1000),
    },
    { name: 'setting_register', ...number_or_0 },
    { name: 'notification_list', ...objectid_array_or_empty },
    { name: 'sensor_type', ...number_or_0 },
    { name: 'recovery_list', ...objectid_array_or_empty },
    { name: 'upper_notification_list', ...objectid_array_or_empty },
    { name: 'impulse_frequency', ...number_or_0, default_from_op: 1 },
    { name: 'calibration', ...objectid_or_null },
    { name: 'position', ...number_or_0 },
    { name: 'units', ...number_or_0 },
];
const { fromStr } = getFieldParser(analog_input_fields);
function analogInputs2Str(obj_id, obj) {
    const kom_volt_multiplier = AnalogInput.voltFromSettingRegister(obj);
    return new ObjectLine(obj.id, obj_id, [
        obj.physical_input_num !== -1 ? obj.physical_input_num : 255,
        obj.name,
        obj.upper_threshold == null
            ? 0
            : Math.round(obj.upper_threshold * kom_volt_multiplier),
        obj.lower_threshold == null
            ? 0
            : Math.round(obj.lower_threshold * kom_volt_multiplier),
        Math.round(obj.active_level_timeout * 1000),
        Math.round(obj.inactive_level_timeout * 1000),
        Number(obj.setting_register),
        obj.notification_list,
        Number(obj.sensor_type),
        (obj.recovery_list || []),
        (obj.upper_notification_list || []),
        Number(obj.impulse_frequency === null ? 1 : obj.impulse_frequency),
        obj.calibration || 0,
        obj.position || 0,
        obj.units || 0,
        ...(obj.rest || []),
    ]);
}
function analogInputsFromStr(id, params) {
    const setting_register = params[6];
    const kom_volt_multiplier = params[8] === 0 && (setting_register & 4) > 0 ? 1000 : 10;
    return {
        ...fromStr(id, params),
        upper_threshold: params[2] / kom_volt_multiplier,
        lower_threshold: params[3] / kom_volt_multiplier,
    };
}
export const analog_inputs_parser = {
    toStr: analogInputs2Str,
    fromStr: analogInputsFromStr,
};
